var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"locale-changer"},_vm._l((_vm.langs),function(lang,i){return _c('span',{key:("Lang" + i),staticClass:"lng-sel",on:{"click":function($event){return _vm.setLocale(lang)}}},[_vm._v(" "+_vm._s(lang)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }